import { Injectable } from '@angular/core';
import {FontServiceBase} from 'storyboard-renderer';
import {AuthService} from "../../../auth/auth.service";

@Injectable()
export class FontService extends FontServiceBase {

  constructor(private authService: AuthService) {
    super();
  }

  getFonts(): Array<any> {
    return this.fonts.filter(item => {
      return !(
        (!this.authService.hasRole('administrator') && item.title === 'BBC Reith Sans') ||
        (!this.authService.hasRole('orf_user') && !this.authService.hasRole('administrator') && item.title === 'Gotham')
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/font.service.ts